const state = {
  rate: [],
  reason: [],
  reason_shipment: [],
  reason_fm: [],
  reason_lm: [],
  rate_id: [],
  reason_id: [],
  slide_screen: [],
};

export default state;
